<div app-landing-page-section-container>
    <app-system-response
        responseType="error"
        message="ServiceDeskRegistrationError"
        basicPrimaryButtonText="Try again"
        basicPrimaryButtonIcon="refresh"
        (basicPrimaryButtonClick)="handleTryAgainClick()"
        flatPrimaryButtonText="Contact our Service Desk"
        (flatPrimaryButtonClick)="handleServiceDeskClick()"
    ></app-system-response>
</div>
